<template>
  <div style="width: 100%; position: relative">
    <a-select
      showSearch
      v-model="localValue"
      placeholder='Enter company name'
      style="width: 100%"
      :defaultActiveFirstOption="false"
      :showArrow="false"
      :filterOption="false"
      @search="handleSearch"
      @change="handleChange"
      notFoundContent=""
      @blur="handleBlur"
    >
      <div slot="dropdownRender" slot-scope="menu">
        <v-nodes :vnodes="menu" />
        <a-divider v-if="noResults" style="margin: 4px 0;" />
        <div @click="addAndSelectNewCompany" v-if="noResults" style="padding: 8px; cursor: pointer;"><a-icon type="plus" /> Add {{ inputValue }}</div>
      </div>
      <a-select-option v-for="c in companies" :key="c.id">{{c.name}}</a-select-option>
    </a-select>
    <a-icon v-if="loadingCompanies" type="loading" />
  </div>
</template>

<script>
  import { debounce } from 'lodash'
  import { mapActions, mapState, mapMutations } from 'vuex'

  export default {
    name: 'CompanyAutocomplete',
    components: {
      VNodes: {
        functional: true,
        render: (h, ctx) => ctx.props.vnodes
      }
    },
    data() {
      return {
        inputValue: ''
      }
    },
    props: ['value', 'onBlur'],
    computed: {
      localValue: {
        get() {
          return this.value
        },
        set(localValue) {this.$emit('input', localValue)}
      },
      noResults: function() {
        return this.inputValue && !this.companies.length && !this.loadingCompanies
      },
      ...mapState('newSubscriptionForm', ['companies', 'loadingCompanies'])
    },
    methods: {
      ...mapActions('newSubscriptionForm', ['fetchCompanies']),
      ...mapMutations('newSubscriptionForm', ['addCompany', 'startLoadingCompanies']),
      handleSearch: function(value) {
        this.inputValue = value
        if(value) this.startLoadingCompanies()
        return this.fetchMatchingCompanies(value)
      },
      fetchMatchingCompanies: debounce(function(value) {
        if(value) this.fetchCompanies(value)
      }, 300),
      handleChange(value) {
        this.localValue = value
      },
      addAndSelectNewCompany() {
        this.addCompany({id: 0, name: this.inputValue})
        this.localValue = 0
      },
      handleBlur() {
        this.onBlur()
      }
    }

  }
</script>

<style scoped lang='stylus'>
  .anticon-loading {
    width: 17px;
    height: 17px;
    position: absolute;
    top: 12px;
    right: 10px;

    svg {
      width: 100%;
      height: 100%;
      fill: $primaryBlue;
    }
  }
</style>
